import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.throwConfetti();
  }

  async throwConfetti() {
    if (!window.confetti) {
      await this.loadConfettiLibrary();
    }

    window.confetti(); // Fire the confetti!
  }

  loadConfettiLibrary() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}